import { AnimatedFlame } from 'app/components/streak/animated-flame';
import { Column } from 'app/design/primitives/box';
import { Button } from 'app/design/primitives/button';
import { Text } from 'app/design/primitives/text';

import { useTranslation } from 'react-i18next';
import { createTheme as createDSTheme } from 'app/shopify';
const theme = createDSTheme();

interface EmptyStreakStateProps {
  onPress: () => void;
}

export const EmptyStreakState = function EmptyStreakState({ onPress }: EmptyStreakStateProps) {
  const { t } = useTranslation('streak');

  return (
    <Column alignItems="center" gap="spacing.general.x5" paddingHorizontal="spacing.general.x4">
      <AnimatedFlame size={96} fontSize={48} discColor={theme.colors['surface.brand.secondary-3.subtle']} />

      <Text fontSize={22} fontWeight="bold" textAlign="center">
        {t('empty.title')}
      </Text>

      <Button onPress={onPress} variant="primary" style={{ borderRadius: 30, minHeight: 50, alignSelf: 'stretch' }}>
        <Text color="white" fontSize={15} fontWeight="600">
          {t('empty.cta')}
        </Text>
      </Button>
    </Column>
  );
};
